import { useEffect, useState } from 'react';
import { apiClient } from '../api';

export type QuestionProTaskStatus =
  'no_token' | 'checking' | 'valid' | 'invalid';

export function useQuestionProTask(
  token?: string | null
): QuestionProTaskStatus {
  const [status, setStatus] = useState<QuestionProTaskStatus>('no_token');

  useEffect(() => {
    if (!token) {
      setStatus('no_token');
      return;
    }

    setStatus('checking');

    apiClient
      .verifyQuestionProToken(token)
      .then((valid) => setStatus(valid ? 'valid' : 'invalid'))
      .catch(() => setStatus('invalid'));
  }, [token]);

  return status;
}
